<template>
	<div class="download">
    <img src="static/img/bg.png" class="bg">
		<div class="content">
      <img src="static/img/logo2.png" class="logo">
      <img src="static/img/logotxt.png" class="logotxt">
      <p>注册成功</p>
      <span>如何开启赚钱第一步</span>
			<a href="javascript:;" @click="trackEvent($event)">点击下载淘金云客服app</a>
		</div>
	</div>
</template>
<script>
export default {
  name: 'download',
  data() {
    return {
			opt_label: this.$route.query.fr ? this.$route.query.fr : 'itaojin'
    }
  },
  mounted() {
		var hm = document.createElement("script");
		hm.src = "https://hm.baidu.com/hm.js?c2c18f245d6de5e40057411877b2018e";
		var s = document.getElementsByTagName("script")[0]; 
		s.parentNode.insertBefore(hm, s);
  },
  methods: {
		trackEvent(e) {
			var a = e.target
			a = $(a)
			window._hmt && window._hmt.push(['_trackEvent', 'APP下载推广', 'download', this.opt_label])
			setTimeout(function() {
				window.location = 'http://t.itaojin.cn/pages/app_distribute.html'
			},100)
		}
  }
}
</script>





// WEBPACK FOOTER //
// download.vue?5df1a376